module.exports = __webpack_public_path__ + "media/soar_notes.8e847808.mp4";